import { setDefaultOptions } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useLayoutStore } from "layout/store";
import { roundAbnt } from "std/math";

export function initBeforeReact(): void {
	clearOld();
	addToProto();
	registerEventsListeners();
	setDefaults();
}

function setDefaults(): void {
	setDefaultOptions({ locale: ptBR });
}

function clearOld(): void {
	if (localStorage.getItem("accessToken")) {
		localStorage.clear();
	}

	if ("serviceWorker" in navigator) {
		navigator.serviceWorker.getRegistrations().then((registrations) => {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
}

function addToProto(): void {
	Number.prototype.roundAbnt = function (decimalPlaces = 2): number {
		return roundAbnt(this.valueOf(), decimalPlaces);
	};
}

function registerEventsListeners(): void {
	window.onunhandledrejection = (event: PromiseRejectionEvent) => {
		throw new Error(event.reason);
	};

	window.addEventListener("resize", () => {
		function isFullScreen() {
			return (
				// @ts-expect-error - existe
				window.fullScreen || (window.innerWidth === screen.width && window.innerHeight === screen.height)
			);
		}

		useLayoutStore.setState({ isFullscreen: isFullScreen() });

		useLayoutStore.setState({
			menuOpen: window.innerWidth >= 1024,
			menuMobile: window.innerWidth < 768,
		});
	});
}
